import { render, staticRenderFns } from "./ParcelamentoLiberacao.vue?vue&type=template&id=3886d91a"
import script from "./ParcelamentoLiberacao.vue?vue&type=script&lang=js"
export * from "./ParcelamentoLiberacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports